import { MD5 } from 'crypto-js';
import React from 'react';

import cn from '../../../../../../utils/cn';

function Tr({ item, handleToggle, loading, isDisabled }) {
    const isPermitted = item?.status;

    return (
        <tr
            className={cn(
                `group border-b border-primary-100 hover:bg-secondary-50 h-12.5 [&>*:first-of-type]:!pl-5 [&>*:last-of-type]:!pr-5 [&>*:last-of-type]:text-right`
            )}
        >
            <td>
                <span className="text-base font-bold">
                    {item?.key === 'admin.manager' ? 'Super Admin' : item?.title}
                </span>
                <br />
                <span className="text-sm">{item?.description}</span>
            </td>

            <td>
                <button
                    type="button"
                    className={cn('w-[40px] h-[20px] rounded-[50px] p-[3px] bg-gray-400', {
                        'bg-secondary': isPermitted,
                        'pointer-events-none grayscale': loading || isDisabled
                    })}
                    onClick={() => handleToggle(item)}
                >
                    <span
                        className={`w-[16px] h-full block bg-white rounded-[50px] ${
                            isPermitted ? 'float-end' : ''
                        }`}
                    />
                </button>
            </td>
        </tr>
    );
}

function CustomersSubscriptionTableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>Title</span>
                </th>

                <th scope="col" className="w-30 text-center">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function TableWeb({ permissions, handleToggle, pageLoading, loading, isDisabled }) {
    return (
        <div
            className={`customers_subscription_table mb-52 ${pageLoading ? 'placeholder-mode' : ''}`}
        >
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <CustomersSubscriptionTableHeader />
                <tbody>
                    {permissions?.map((item, index) => (
                        <Tr
                            key={`${MD5(index)}_${item?.title}`}
                            item={item}
                            handleToggle={handleToggle}
                            loading={loading}
                            isDisabled={isDisabled}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
